// Modal principal para crear/editar propiedades

import React from 'react';
import { X } from 'lucide-react';
import { usePropertyForm } from './PropertyModal/usePropertyForm';
import PropertyForm from './PropertyModal/PropertyForm';

/**
 * Modal para crear o editar una propiedad
 * Versión refactorizada con lógica separada
 */
const PropertyModal = ({ 
  property, 
  properties, 
  bids, 
  onSave, 
  onClose, 
  saving = false 
}) => {
  const {
    formData,
    photoUrlsText,
    setPhotoUrlsText,
    adminEmailsText,
    setAdminEmailsText,
    documentUrlsText,
    setDocumentUrlsText,
    error,
    setError,
    isEditing,
    hasBids,
    isPriceEditable,
    handleChange,
    createNewProperty,
    updateExistingProperty
  } = usePropertyForm(property, properties, bids);

  /**
   * Manejar el envío del formulario
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      if (isEditing) {
        await updateExistingProperty(onSave);
      } else {
        await createNewProperty(onSave);
      }
    } catch (error) {
      console.error('Error saving property:', error);
      setError(error.message || 'Error al guardar la propiedad. Intenta de nuevo.');
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50" 
      onClick={onClose}
    >
      <div
        className="bg-slate-800 rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto border border-slate-700"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-6 border-b border-slate-700 flex items-center justify-between sticky top-0 bg-slate-800 z-10">
          <h2 className="text-2xl font-bold text-white">
            {isEditing ? 'Editar Propiedad' : 'Nueva Propiedad'}
          </h2>
          <button 
            onClick={onClose} 
            disabled={saving}
            className="text-slate-400 hover:text-white transition-all disabled:opacity-50"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Form */}
        <PropertyForm
          formData={formData}
          photoUrlsText={photoUrlsText}
          adminEmailsText={adminEmailsText}
          documentUrlsText={documentUrlsText}
          error={error}
          isEditing={isEditing}
          isPriceEditable={isPriceEditable}
          property={property}
          saving={saving}
          onChange={handleChange}
          onPhotoUrlsChange={setPhotoUrlsText}
          onAdminEmailsChange={setAdminEmailsText}
          onDocumentUrlsChange={setDocumentUrlsText}
          onSubmit={handleSubmit}
          onCancel={onClose}
        />
      </div>
    </div>
  );
};

export default PropertyModal;